import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';

const Blog = ({ blogs }) => {
  return (
    <section className="fadin-blog pt-0">
      <Container className="m-width">
        <Row>
          <Col md={12} className="text-center">
            <div className="section-title mb-2">
              <h2>Other Page</h2>
              <img src="assets/images/title-line.png" alt="title-line" className="img-fluid" />
            </div>
          </Col>
        </Row>
        <Row className="mt-35 pages-space">
          {blogs.map((val, i) => (
            <Col xl={4} lg={6} xs={12} className="text-center" key={i}>
              <div>
                <Link to={val.link} target="_blank" rel="noopener noreferrer">
                  <span className="pc-bg">
                    <span style={{ backgroundImage: val.imgUrl }} className="img-scroll"></span>
                  </span>
                </Link>
              </div>
              <h2 className="demo-title">{val.lable}</h2>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Blog;
